import { unlockScroll } from '../utils';

const initialize = () => {
    $('[data-zoom-close]').click(function(e) {
        e.preventDefault();
        $('[data-zoom-overlay]').removeClass('active');
        unlockScroll();
    });
};

export default {
    initialize,
};

